<template>
  <div id="jobs">
    <div class="col-sm-4">
      <div class="card h-100">
        <div class="card-body">
          <h3 class="card-title">{{ name }}</h3>
          <p class="card-text">{{ code }}</p>
          <p class="card-text">Candidatos: {{ total }}</p>
          <p class="card-text">{{ date }}</p>
          <span v-if="state == 0">
            <p class="card-text" style="color:green"><b>Visível</b></p></span
          >
          <span v-else-if="state == 1"
            ><p class="card-text" style="color:red"><b>Invisivel</b></p></span
          >
          <button href="#" class="btn btn-primary" @click="selectId(id)">
            Ver Candidatos
          </button>
          <span v-if="code == 'ESP'">
            <button
              href="#"
              class="btn btn-primary"
              @click="editState(id)"
              disabled
            >
              Alterar Estado
            </button>
            <button
              href="#"
              class="btn btn-primary"
              @click="addJobs()"
              disabled
            >
              Duplicar
            </button>
            <button
              href="#"
              class="btn btn-danger"
              @click="delJob(id)"
              disabled
            >
              🗑️
            </button>
          </span>
          <span v-else
            ><button href="#" class="btn btn-primary" @click="editState(id)">
              Alterar Estado
            </button>
            <button href="#" class="btn btn-primary" @click="addJobs()">
              Duplicar
            </button>
            <button href="#" class="btn btn-danger" @click="delJob(id)">
              🗑️
            </button></span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    name: String,
    code: String,
    total: Number,
    date: String,
    id: Number,
    state: Number,
    description: String,
    profile: String,
    offer: String,
  },
  methods: {
    selectId(idValue) {
      this.$router.push({
        name: "candidates",
        params: { id: idValue },
      });
    },
    async editState(id) {
      try {
        await this.$store.dispatch("putJobState", {
          id: id,
        });
        this.$swal({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 1500,
          icon: "success",
          title: `Estado do ${this.name} alterado`,
        });
      } catch (err) {
        this.$swal({
          title: err.data.status,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
      this.$parent.getAllJobs();
    },
    async delJob(id) {
      this.$swal({
        title: "Têm a certeza que pretende eliminar esta oferta de Emprego?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, Eliminar!",
      }).then((result) => {
        if (result.isConfirmed) {
          try { 
            this.$store.dispatch("deleteJob", {
              id: id,
            });
            this.$swal({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 1500,
              icon: "success",
              title: `Estado do ${this.name} alterado`,
            });
            this.$parent.getAllJobs();
          } catch (err) {
            this.$swal({
              title: err.data.status,
              icon: "error",
              confirmButtonText: "Ok!",
            });
          }
        }
      });
    },
    async addJobs() {
      this.$swal({
        title: "Quer duplicar este trabalho?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, Adicionar!",
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            this.$store.dispatch("postJobs", {
              name: this.name,
              description: this.description,
              profile: this.profile,
              offer: this.offer,
              state: this.state,
            });
            this.$swal({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 1500,
              icon: "success",
              title: "Trabalho Criado!",
            });
            this.$parent.getAllJobs();
          } catch (err) {
            this.$swal({
              title: err.data.status,
              icon: "error",
              confirmButtonText: "Ok!",
            });
          }
        }
      });
    },
  },
};
</script>
<style scoped>
.card {
  background: #f5f7fa;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.08), 0 0 6px rgba(0, 0, 0, 0.05);
  transition: 0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12),
    0.3s box-shadow,
    0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);
  border: none;
  width: 350px;
  min-height: 280px;
}
.card {
  margin: 10px 5px 0px 5px;
  text-align: center;
}
a {
  color: white;
  text-decoration: none;
}
button {
  margin-top: 15px;
  margin-right: 10px;
}
</style>
